import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactUs = () => {
  const navigate = useNavigate();
  const [footerAddress, setFooterAddress] = useState([]);
  const [footerSocial, setFooterSocial] = useState([]);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    subject: '',
    message: '',
    messageStatus: 'UnRead',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleMessage = (event) => {
    event.preventDefault();

    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/add-message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((result) => {
        alert('Message sent successfully');
        navigate('/thanks');
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Failed to send message. Please try again.');
      });
  };

  return (
    <div>
      <section className="message-section about-section mt-5" id='contact-sec'>
        <div className="container">
          <figure className="mb-0 price-circle">
            <img className="img-fluid" src="./assets/images/price-circle.png" alt="" />
          </figure>
          <div className="row position-relative">
            <figure className="mb-0 price-sidecircle">
              <img className="img-fluid" src="./assets/images/price-sidecircle.png" alt="" />
            </figure>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="manage_wrapper">
                <figure className="mb-0 manage-phoneback">
                  <img src="./assets/images/manage-phoneback.png" alt="" />
                </figure>
                <figure className="mb-0 manage-phone2">
                  <img className="img-fluid" src="https://i.ibb.co.com/jZPfqhWH/assistance-en-ligne-pour-nous-contacter-page-4880591-4062780.webp" alt="" />
                </figure>
                <figure className="mb-0 manage-phone1">

                </figure>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="manage_content" data-aos="fade-up">
                <div className="message_content">
                  <h2>Send Us a Message</h2>
                  <form onSubmit={handleMessage} id="contactpage" method="POST">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group mb-0">
                          <input
                            type="text"
                            className="form_style"
                            placeholder="Your Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group mb-0">
                          <input
                            type="email"
                            className="form_style"
                            placeholder="Your Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group mb-0">
                          <input
                            type="text"
                            className="form_style"
                            placeholder="Your Phone"
                            name="number"
                            value={formData.number}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group mb-0">
                          <input
                            type="text"
                            className="form_style"
                            placeholder="Your Subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <input
                          type="hidden"
                          name="messageStatus"
                          value="UnRead"
                        />
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group mb-0">
                          <textarea
                            className="form_style"
                            placeholder="Message"
                            rows={3}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="manage-button text-center">
                      <button type="submit" className="submit_now">Submit Now</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="feature-aboutsection contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="feature_aboutheading">
                <h2>Our Contact Information</h2>
              </div>
            </div>
          </div>
          {
            footerAddress.map(e => <div className="feature-block">
              <div className="row" data-aos="fade-up">
                <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="feature_aboutcontent box hover1">
                    <div className="icon-size1">
                      <figure className="mb-0 contact-addressicon">
                        <img src="./assets/images/contact-addressicon.png" alt="" className="img-fluid" />
                      </figure>
                    </div>
                    <h5>Address</h5>
                    <p className="mb-0 text-size-18">{e.location}</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="feature_aboutcontent box hover2">
                    <div className="icon-size1 icon-size2">
                      <figure className="mb-0 contact-phoneicon">
                        <img src="./assets/images/contact-phoneicon.png" alt="" className="img-fluid" />
                      </figure>
                    </div>
                    <h5>Phone</h5>
                    <a href="/" className="mb-0 text-decoration-none text-size-18">{e.phoneNumber}</a><br />
                    
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="feature_aboutcontent box hover3">
                    <div className="icon-size1 icon-size3">
                      <figure className="mb-0 contact-emailicon">
                        <img src="./assets/images/contact-emailicon.png" alt="" className="img-fluid" />
                      </figure>
                    </div>
                    <h5>Email</h5>
                    <a href="/" className="mb-0 text-decoration-none text-size-18">{e.emailAddress}</a><br />
                   
                  </div>
                </div>
              </div>
            </div>)
          }

        </div>
      </section>
    </div>
  );
};

export default ContactUs;
